<template>
    <span
        class="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-semibold tracking-wide"
        :class="statusClasses"
    >
        <span class="h-1.5 w-1.5 rounded-full" :class="dotClass"></span>
        {{ status }}
    </span>
</template>

<script>
export default {
    props: ["audit"],
    computed: {
        status() {
            return this.audit.status === "open" ? "Aberto" : "Encerrado";
        },
        statusClasses() {
            return this.audit.status === "open"
                ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400"
                : "bg-gray-100 text-gray-600 dark:bg-gray-600/30 dark:text-gray-400";
        },
        dotClass() {
            return this.audit.status === "open"
                ? "bg-emerald-500 dark:bg-emerald-400"
                : "bg-gray-400 dark:bg-gray-500";
        },
    },
};
</script>
